export const NEW = "new"
export const IN_TOUCH = "in_touch"
export const SAILED = "sailed"
export const EXTERNAL = "external"
export const BLOCKED = "blocked"
